/**
 * @generated SignedSource<<17261d2f768d0ead09ae3be4ed420729>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type QuickChargeInput = {
  description?: string | null;
  isForTrial: boolean;
  price: number;
  returnUrlFromApproval?: string | null;
};
export type switchSalesChannelDialogCreateQuickChargeMutation$variables = {
  input: QuickChargeInput;
};
export type switchSalesChannelDialogCreateQuickChargeMutation$data = {
  readonly createQuickCharge: string | null;
};
export type switchSalesChannelDialogCreateQuickChargeMutation = {
  response: switchSalesChannelDialogCreateQuickChargeMutation$data;
  variables: switchSalesChannelDialogCreateQuickChargeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "createQuickCharge",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "switchSalesChannelDialogCreateQuickChargeMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "switchSalesChannelDialogCreateQuickChargeMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "7a12deb4390fc4616c98ad9f1afef879",
    "id": null,
    "metadata": {},
    "name": "switchSalesChannelDialogCreateQuickChargeMutation",
    "operationKind": "mutation",
    "text": "mutation switchSalesChannelDialogCreateQuickChargeMutation(\n  $input: QuickChargeInput!\n) {\n  createQuickCharge(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "ddd52a77d31b6a49a36348f5cbc5264c";

export default node;
